import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { InstanceService } from '@commonspirit/ngx-instance';
import { ConfigurationKey } from '../../core/models/configuration-key';
import { SessionConstants } from 'src/app/shared/models/v2/search';

@Component({
  selector: 'fal-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
  title = 'Find a Location';
  searchHomeDescription: string;
  showERInfo: boolean;
  doSVG = false;
  emergencyText: string = this.service.getConfiguration(ConfigurationKey.EmergencyText)?.value as string;

  constructor(private service: InstanceService, private titleService: Title) {
    this.searchHomeDescription = this.service.getConfiguration(ConfigurationKey.SearchHomeDescription)?.value as string;

    this.showERInfo = (this.service.getConfiguration(ConfigurationKey.ShowERInfo)?.value as boolean) ?? true;
    const marketCode = this.service.getConfiguration(ConfigurationKey.MarketCodes)?.value as string;

    this.title = `Find a location | Location Search | ${marketCode?.toUpperCase()}`;
  }

  ngOnInit() {
    window.sessionStorage.removeItem(SessionConstants.SelectedSuggestion);
    this.titleService.setTitle(this.title);
    window.sessionStorage.removeItem(SessionConstants.SelectedSpecialtiesFilter);
    window.sessionStorage.removeItem(SessionConstants.SelectedLocationTypesFilter);
    window.sessionStorage.removeItem(SessionConstants.SelectedRadiusFilter);
  }
}
